{
  "name": "angular-srcs",
  "version": "22.2.4",
  "private": true,
  "description": "Angular - a web framework for modern web apps",
  "homepage": "https://github.com/angular/angular",
  "bugs": "https://github.com/angular/angular/issues",
  "license": "MIT",
  "packageManager": "pnpm@11.28.9",
  "engines": {
    "npm": "Please use pnpm instead of NPM to install dependencies",
    "yarn": "Please use pnpm instead of Yarn to install dependencies",
    "pnpm": "11.28.9"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/angular/angular.git"
  },
  "scripts": {
    "prepare": "husky",
    "ng-dev": "ng-dev",
    "build": "node scripts/build/build-packages-dist.mts",
    "test": "bazelisk test",
    "test:ci": "bazelisk test -- //... -//integration/... -//adev/... -//vscode-ng-language-service/... -//devtools/... -//modules/ssr-benchmarks/...",
    "integration-tests:ci": "bazelisk test -- //integration/...",
    "test-tsec": "bazelisk test //... --build_tag_filters=tsec --test_tag_filters=tsec",
    "lint": "pnpm --silent tslint && pnpm --silent ng-dev format changed --check",
    "tslint": "tslint -c tslint.json --project tsconfig-tslint.json",
    "public-api:check": "node goldens/public-api/manage.js test",
    "public-api:update": "node goldens/public-api/manage.js accept",
    "symbol-extractor:check": "node tools/symbol-extractor/run_all_symbols_extractor_tests.js test",
    "symbol-extractor:update": "node tools/symbol-extractor/run_all_symbols_extractor_tests.js accept",
    "ts-circular-deps:check": "pnpm --silent ng-dev ts-circular-deps check --config ./packages/circular-deps-test.conf.cjs",
    "check-tooling-setup": "tsc --project scripts/tsconfig.json",
    "devtools:devserver": "ibazel run //devtools/src:devserver",
    "devtools:test:e2e": "cypress run --project ./devtools/cypress",
    "devtools:e2e:open": "cypress open --project ./devtools/cypress",
    "devtools:build:chrome": "bazelisk build --//devtools/projects/shell-browser/src:flag_browser=chrome //devtools/projects/shell-browser/src:prodapp",
    "devtools:build:firefox": "bazelisk build --config snapshot-build-firefox --//devtools/projects/shell-browser/src:flag_browser=firefox //devtools/projects/shell-browser/src:prodapp",
    "devtools:build:chrome:debug": "pnpm --silent devtools:build:chrome --//devtools:debug",
    "devtools:build:chrome:release": "pnpm --silent devtools:build:chrome",
    "devtools:build:firefox:debug": "pnpm --silent devtools:build:firefox --//devtools:debug",
    "devtools:build:firefox:release": "pnpm --silent devtools:build:firefox --jobs 4",
    "devtools:test": "bazelisk test --//devtools/projects/shell-browser/src:flag_browser=chrome -- //devtools/...",
    "devtools:test:unit": "bazelisk test -- //devtools/...",
    "devtools:release": "node devtools/tools/release.mts",
    "adev": "[[ -n $CI ]] && echo 'Cannot run this pnpm script on CI' && exit 1 || ibazel run //adev:build.serve",
    "adev:build": "[[ -n $CI ]] && echo 'Cannot run this pnpm script on CI' && exit 1 || bazel build //adev:build",
    "dev": "pnpm --filter=dev-app dev",
    "dev:prod": "pnpm --filter=dev-app dev:prod",
    "dev:build": "pnpm --filter=dev-app dev:build",
    "benchmarks": "node scripts/benchmarks/index.mts",
    "diff-release-package": "node scripts/diff-release-package.mts",
    "zonejs:release": "pnpm --filter=zone.js release"
  },
  "// 1": "dependencies are used locally and by bazel",
  "dependencies": {
    "@angular-devkit/core": "22.2.5",
    "@angular-devkit/schematics": "22.2.5",
    "@angular/animations": "workspace:*",
    "@angular/aria": "22.2.5",
    "@angular/benchpress": "workspace:*",
    "@angular/build": "22.2.5",
    "@angular/cdk": "22.2.5",
    "@angular/cli": "22.2.5",
    "@angular/common": "workspace:*",
    "@angular/compiler": "workspace:*",
    "@angular/compiler-cli": "workspace:*",
    "@angular/core": "workspace:*",
    "@angular/elements": "workspace:*",
    "@angular/forms": "workspace:*",
    "@angular/language-service": "workspace:*",
    "@angular/localize": "workspace:*",
    "@angular/material": "22.2.5",
    "@angular/platform-browser": "workspace:*",
    "@angular/platform-browser-dynamic": "workspace:*",
    "@angular/platform-server": "workspace:*",
    "@angular/router": "workspace:*",
    "@angular/service-worker": "workspace:*",
    "@angular/ssr": "22.2.5",
    "@angular/upgrade": "workspace:*",
    "@babel/cli": "8.0.4",
    "@babel/core": "8.0.1",
    "@babel/generator": "8.0.0",
    "@rollup/plugin-commonjs": "^29.0.0",
    "@rollup/plugin-node-resolve": "^16.0.0",
    "@schematics/angular": "22.2.5",
    "@types/angular": "^1.6.47",
    "@types/chrome": "^0.2.0",
    "@types/dom-navigation": "^1.0.5",
    "@types/jasmine": "^6.0.0",
    "@types/jasminewd2": "^2.0.8",
    "@types/node": "^20.14.8",
    "@types/selenium-webdriver": "3.0.7",
    "@types/semver": "^7.3.4",
    "@types/yargs": "^17.0.3",
    "angular-1.5": "npm:angular@1.5",
    "angular-1.6": "npm:angular@1.6",
    "angular-1.7": "npm:angular@1.7",
    "angular-1.8": "npm:angular@1.8",
    "angular-mocks-1.5": "npm:angular-mocks@1.5",
    "angular-mocks-1.6": "npm:angular-mocks@1.6",
    "angular-mocks-1.7": "npm:angular-mocks@1.7",
    "angular-mocks-1.8": "npm:angular-mocks@1.8",
    "chalk": "^6.0.0",
    "diff": "^9.0.0",
    "domino": "https://github.com/angular/domino.git#a0d9c35737220cea1a70bdcaf7bde94518271dbb",
    "esbuild": "0.28.2",
    "http-server": "^14.0.0",
    "jasmine": "6.3.0",
    "jasmine-core": "6.3.0",
    "jasmine-reporters": "^2.5.2",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "^3.1.0",
    "karma-firefox-launcher": "^2.1.0",
    "karma-jasmine": "^5.0.0",
    "karma-sourcemap-loader": "^0.4.0",
    "magic-string": "^1.0.0",
    "protractor": "^7.0.0",
    "reflect-metadata": "^0.2.0",
    "rollup": "4.63.0",
    "rollup-plugin-dts": "^6.1.1",
    "rxjs": "^7.0.0",
    "selenium-webdriver": "3.5.0",
    "source-map": "0.8.0",
    "source-map-support": "0.5.21",
    "tinyglobby": "^0.2.12",
    "tslib": "^2.3.0",
    "tslint": "6.1.3",
    "typescript": "6.0.3",
    "ws": "^8.15.0",
    "yargs": "^18.0.0",
    "zone.js": "0.16.2"
  },
  "// 2": "devDependencies are not used under Bazel. Many can be removed after test.sh is deleted.",
  "devDependencies": {
    "@actions/core": "^3.0.0",
    "@actions/github": "^9.0.0",
    "@angular/ng-dev": "https://github.com/angular/dev-infra-private-ng-dev-builds.git#d2b6dfe820fcd82fc06e4809b53e30fe4853b6eb",
    "@bazel/bazelisk": "^1.7.5",
    "@bazel/buildifier": "^8.0.0",
    "@bazel/ibazel": "0.28.0",
    "@inquirer/prompts": "^8.0.0",
    "@types/adm-zip": "^0.5.0",
    "@types/cldr": "^7.1.4",
    "@types/cldrjs": "^0.4.22",
    "adm-zip": "^0.6.0",
    "cldr": "8.0.0",
    "cldrjs": "0.5.5",
    "conventional-changelog": "^8.0.0",
    "cypress": "16.0.0",
    "firebase-tools": "^15.0.0",
    "get-tsconfig": "^4.10.1",
    "gulp": "^5.0.0",
    "gulp-conventional-changelog": "^5.0.0",
    "husky": "9.1.7",
    "karma-coverage": "^2.2.1",
    "karma-jasmine-html-reporter": "^2.2.0",
    "prettier": "^3.8.0",
    "rollup-plugin-sourcemaps2": "^0.5.1",
    "semver": "^7.3.5",
    "ts-node": "^10.9.1",
    "tsec": "0.2.9",
    "tslint-no-toplevel-property-access": "0.0.2"
  },
  "resolutions": {
    "typescript": "6.0.3"
  }
}
